var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentStarSystemId > 0)?_c('g',_vm._l((_vm.systemObjects),function(sprite,index){return _c('g',{key:'sprite-' + index},[_c('sprite-transform',{attrs:{"sprite":sprite,"objectIndex":index,"type":sprite.type}})],1)}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }